module.exports = __webpack_public_path__ + "static/media/cta_arrow.216af87d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cta_arrow.svg
// module id = 52
// module chunks = 0